import { render, staticRenderFns } from "./CustomHeader.vue?vue&type=template&id=39474d88&scoped=true"
import script from "./CustomHeader.vue?vue&type=script&lang=js"
export * from "./CustomHeader.vue?vue&type=script&lang=js"
import style0 from "./CustomHeader.scss?vue&type=style&index=0&id=39474d88&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39474d88",
  null
  
)

export default component.exports